import { gql } from '@apollo/client';

export const CREATE_SESSION_PURCHASE = gql`
  mutation CREATE_SESSION_PURCHASE(
    $sessionId: ID!
    $registrationId: String
    $candidates: [CandidateInput]!
    $preptools: [PrepToolInput]
    $discount: String
    $referrer: String
    $purchaserId: Int
    $isCpfRequired: Boolean
  ) {
    createSessionPurchase(
      sessionId: $sessionId
      registrationId: $registrationId
      candidates: $candidates
      preptools: $preptools
      discount: $discount
      referrer: $referrer
      purchaserId: $purchaserId
      isCpfRequired: $isCpfRequired
    ) {
      ... on CandidatesAddedInSessionSuccessfully {
        registrationId
      }
      ... on CandidatesCanNotBeAddedInSession {
        errorList
        errorCodes
      }
      ... on DuplicatedCandidates {
        parameters
      }
    }
  }
`;
